import { useAppDispatch, useAppSelector } from 'flow/hooks/useRedux';
import { useHistory } from 'react-router-dom';
import { navigateBack } from 'flow/actions/navigate-actions';
import { getIsSinglePaneMode } from 'flow/selectors/selectors';
import { LocationType } from 'flow/types/Location';
import BackButton from 'flow/components/ui-components/BackButton';

const TicketBackButton = () => {
    const dispatch = useAppDispatch();
    const isSinglePaneMode = useAppSelector(getIsSinglePaneMode);
    const history = useHistory<LocationType>();
    return isSinglePaneMode ? (
        <div className="flex items-center justify-center">
            <BackButton
                onClick={() => dispatch(navigateBack(history.location))}
            />
        </div>
    ) : null;
};

export default TicketBackButton;
